module.exports = __webpack_public_path__ + "media/images/admin/icons/youtube-993a2994b3d0e70225e185161721f680.svg";